<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>{{ Ticket && 'edit' || 'add' }}</mat-icon>
      {{ Ticket && 'Edit' || 'Add' }} Event | {{ eventTitle }} {{ EventLocation
      && ' | ' + EventLocation.title || '' }} {{ startDate && ' | ' + (
      startDate | date : 'dd/MM/yyyy') || '' }}
    </h1>
  </section>
  <section mat-dialog-content>
    <section class="tickets">
      <h2>Tickets</h2>
      <mat-form-field>
        <mat-label
          >Total Tickets (sold: {{ticketsSold}}, available:
          {{form.controls['totalTickets'].value - ticketsSold}})
        </mat-label>
        <input
          [min]="ticketsSold"
          formControlName="totalTickets"
          matInput
          type="number"
          />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Tickets per Partner</mat-label>
        <input
          [min]="0"
          formControlName="ticketsPerPartner"
          matInput
          type="number"
          />
      </mat-form-field>
    </section>
    <section class="prices">
      <h2>Prices</h2>
      @if (form.get('prices')) {
        @for (price of prices.value; track price; let i = $index) {
          @if (price.label) {
            <mat-form-field>
              <mat-label>{{ price.label }}</mat-label>
              <span matPrefix>&pound;&nbsp;</span>
              <input
                [id]="price.label"
                matInput
                step="0.01"
                type="number"
                (input)="updatePrice($event.target)"
                [value]="price.price"
                />
              @if (i > 0) {
                <button
                  (click)="removePriceOption(i)"
                  mat-icon-button
                  matSuffix
                  >
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </mat-form-field>
          }
        }
      }
      <mat-form-field [floatPlaceholder]="'never'">
        <mat-label>Add Price Option</mat-label>
        <mat-select
          #priceSelect
          (selectionChange)="addPriceOption(form.controls['selectPriceOption'].value)"
          formControlName="selectPriceOption"
          >
          <mat-option>-- None --</mat-option>
          @for (priceLabel of filterPriceOptions(); track priceLabel) {
            <mat-option
              [value]="priceLabel"
              >
              {{ priceLabel.label }}
            </mat-option>
          }
          <mat-option (click)="addOption()">-- Option/Supplement --</mat-option>
        </mat-select>
      </mat-form-field>
    </section>
    <section class="delivery">
      <mat-form-field>
        <mat-select
          formControlName="deliveryMethod"
          placeholder="Delivery Method"
          required
          >
          @for (method of deliveryMethods; track method) {
            <mat-option
              [value]="method.slug"
              >
              {{method.label}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </section>
    <section class="dates">
      <h2>Dates</h2>
      <ticket-date-picker
        [ParentFormGroup]="form"
        [endDate]="form.controls['endDate'].value"
        [startDate]="form.controls['startDate'].value"
        [stagedRelease]="form.controls['stagedRelease'].value"
        [releaseDate]="form.controls['stagedReleaseDate'].value"
      ></ticket-date-picker>
    </section>
  </section>
  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
      >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      (click)="resetForm()"
      mat-button
      matTooltip="Reset form."
      type="button"
      >
      <mat-icon>replay</mat-icon>
      Reset
    </button>
    <button
      [disabled]="!form.valid"
      mat-button
      matTooltip="Save ticket."
      type="submit"
      >
      <mat-icon>save</mat-icon>
      Save
    </button>
  </section>
</form>
